import { render, staticRenderFns } from "./GroupLegendInfoButton.vue?vue&type=template&id=ee1bb4ba&scoped=true&"
import script from "./GroupLegendInfoButton.vue?vue&type=script&lang=js&"
export * from "./GroupLegendInfoButton.vue?vue&type=script&lang=js&"
import style0 from "./GroupLegendInfoButton.vue?vue&type=style&index=0&id=ee1bb4ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1bb4ba",
  null
  
)

/* custom blocks */
import block0 from "./GroupLegendInfoButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
